// extracted by mini-css-extract-plugin
export var backdropBlur = "_6g-0";
export var body = "_6g-5";
export var bodyScroll = "_6g-6";
export var columnFooter = "_6g-7";
export var columnFooterFlush = "_6g-8";
export var contentColumn = "_6g-4";
export var frame = "_6g-3";
export var heroContent = "_6g-c";
export var heroOverlay = "_6g-b";
export var image = "_6g-a";
export var imageWrapper = "_6g-9";
export var modal = "_6g-1";
export var modalMain = "_6g-2";
export var productHeader = "_6g-d";
export var productHeaderIcon = "_6g-e";
export var productHeaderName = "_6g-f";
export var progressIndicator = "_6g-g";